jQuery(function () {
    var renovationHeadingInput = $('#renovation-edit-heading');
    if (renovationHeadingInput.length < 1) {
        return;
    }
    var renovationId = $('.renovation-id').data('id');
    $('.js-renovation-show-remove-popup-btn').on('click', function () {
        $('#renovation-remove-popup').closest('.popup-overlay').addClass('visible');
    });
    $('.js-renovation-remove-btn').on('click', function () {
        $.ajax({
            type: 'POST',
            url: '/renovering/ta-bort',
            data: { id: renovationId },
            success: function () {
                document.location.href = '/underhallsplan/renoveringar';
            }
        });
    });
    $('.js-renovation-edit-popup-btn').on('click', function () {
        $('#renovation-edit-popup').closest('.popup-overlay').addClass('visible');
        renovationHeadingInput.val(renovationHeadingInput.attr('value'));
    });
    $('.js-renovation-reset-heading').on('click', function () {
        updateRenovationHeading(null);
    });
    $('.js-renovation-edit-save-btn').on('click', function () {
        var name = renovationHeadingInput.val();
        updateRenovationHeading(name);
    });
    function updateRenovationHeading(name) {
        $.ajax({
            type: 'POST',
            url: '/renovering/byt-namn',
            data: { id: renovationId, customHeading: name },
            success: function () {
                document.location.reload();
            }
        });
    }
    $('.js-form-feedback-btn').one('click', function (e) {
        var _this = this;
        e.preventDefault();
        $(this).addClass('loading').val('Uppdaterar...');
        setTimeout(function () { $(_this).closest('form').submit(); }, 1000);
    });
});
